import React, { useEffect, useRef } from 'react';
import { CardRemoveButton } from 'site-modules/profile/components/shared/card-remove-button/card-remove-button';
import { CardRemoveOverlay } from 'site-modules/profile/components/shared/card-remove-dialog/card-remove-overlay';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';

export function cardRemoveDialog(WrappedComponent) {
  function CardRemoveDialogWrapper({
    dialogClassName,
    canRemove = true,
    removeCard,
    textLabel,
    ariaLabel,
    ...restProps
  }) {
    const wrapperRef = useRef();
    const [isOverlayMode, toggleMode] = useToggle(false);
    const closeRef = useRef();

    function close() {
      toggleMode();
      closeRef.current.focus();
    }

    useEffect(() => {
      if (isOverlayMode) {
        const interactiveElements = Array.from(
          wrapperRef.current.querySelectorAll(
            'a[href], button, input, textarea, select, summary, [tabindex]:not([tabindex="-1"])'
          )
        ).filter(element => element.getAttribute('tabindex') !== '-1');

        interactiveElements.forEach(element => {
          element.setAttribute('data-tabindex', true);
          element.setAttribute('tabindex', -1);
        });
      } else {
        const interactiveElements = wrapperRef.current.querySelectorAll('[data-tabindex]');
        interactiveElements.forEach(element => {
          element.removeAttribute('data-tabindex');
          element.removeAttribute('tabindex');
        });
      }
    }, [isOverlayMode]);

    return (
      <div className="pos-r h-100">
        <div aria-hidden={isOverlayMode} className={dialogClassName} ref={wrapperRef}>
          <WrappedComponent {...restProps} />
          {canRemove && (
            <CardRemoveButton
              onClick={toggleMode}
              trackingId="close_filter_panel"
              className="p-0_25 me-0_5 mt-0_5"
              innerRef={closeRef}
              ariaLabel={ariaLabel}
            />
          )}
        </div>
        {isOverlayMode && (
          <CardRemoveOverlay
            toggleOverlay={close}
            removeCard={removeCard}
            textLabel={textLabel}
            ariaLabel={ariaLabel}
          />
        )}
      </div>
    );
  }
  CardRemoveDialogWrapper.displayName = `CardRemoveComponentWrapper(${WrappedComponent.name})`;

  return CardRemoveDialogWrapper;
}
